import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../authentication/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
// Removed WalletDisplay import
import '../styles/Header.css';
import InstantFlowsLogo from './logos/InstantFlowsLogo-1.png';
// import '../i18n';
// import { useTranslation } from 'react-i18next';

function Header() {
  // Updated to remove walletBalance, add credits
  const { user, logout, isAdmin, credits, lastFreeResearch, hasActiveSubscription } = useAuth();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // const { t, i18n } = useTranslation();

  // useEffect(() => {
  //   i18n.changeLanguage(navigator.language);
  // }, [i18n]);

  const menuRef = useRef(null);
  const toggleRef = useRef(null);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const getNextFreeResearchDate = () => {
    if (!lastFreeResearch) return null;
    const lastDate = new Date(lastFreeResearch);
    const nextDate = new Date(lastDate.getTime() + (7 * 24 * 60 * 60 * 1000));
    return nextDate > new Date() ? nextDate : null;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current && !menuRef.current.contains(event.target) &&
        toggleRef.current && !toggleRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuRef, toggleRef]);

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="logo-link">
          <img src={InstantFlowsLogo} alt="InstantFlows Logo" className="logo" />
        </Link>
        <button 
          ref={toggleRef}
          className={`menu-toggle ${isMenuOpen ? 'open' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)} 
          aria-expanded={isMenuOpen} 
          aria-label={isMenuOpen ? "Close Menu" : "Open Menu"}
        >
          <span className="menu-icon"></span>
        </button>

        <nav ref={menuRef} className={`overlay-nav ${isMenuOpen ? 'open' : ''}`}>
          <ul className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
            <li><Link to="/about">About us</Link></li>
            <li><Link to="/ourpersonas">Personas</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
            <li><Link to="/blogs">Blogs</Link></li>
            <li className="use-cases-menu">
              <Link to="/use-cases">Use Cases</Link>
              <div className="use-cases-dropdown" >
                <Link to="/use-cases/startup-validation">Startup Validation</Link>
                <Link to="/use-cases/branding-feedback">Branding Feedback</Link>
                <Link to="/use-cases/campaign-validation">Campaign Validation</Link>
                <Link to="/exampleresearches">View All Examples</Link>
              </div>
            </li>         
            {user ? (
              <li className="account-menu">
                <div className="auth-buttons-container">
                  <Link to="/research" className="auth-button startresearch-button">
                    App
                  </Link>
                  <div className="account-trigger">

                    <Link to="/account" className="auth-button login-button">
                      My Account
                    </Link>
                    <div className="account-dropdown">
                      <div className="account-info">
                        {hasActiveSubscription && (
                          <div className="subscription-badge" style={{ marginBottom: '8px' }}>
                            <span className="subscription-icon">★</span>
                            <span>Premium Subscription</span>
                          </div>
                        )}
                        <p><strong>Credits:</strong> {isAdmin ? 'Unlimited' : credits}</p>
                        {!isAdmin && !hasActiveSubscription && getNextFreeResearchDate() && (
                          <p className="free-research-info">
                            Next free research: {getNextFreeResearchDate().toISOString().split('T')[0]}
                          </p>
                        )}
                      </div>
                      <div className="dropdown-container">
                        <Link to="/login" className="auth-button login-button" onClick={handleLogout}>
                          Logout
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ) : (
              <li className="auth-buttons-container">
                <Link to="/login" className="auth-button login-button">
                  Login
                </Link>
                <Link to="/login" className="auth-button startresearch-button" 
                  onClick={() => { alert("You need to be logged in first.")}}>
                  Start Research
                </Link>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;